import {appAPI} from "../../../api";
import {ICustomEmoji} from "../model/types";

/** HTTP командных эмодзи (src/emoji/emoji.controller.ts). Ошибки — в thunk'ах. */
export const emojiAPI = {
    list: async (): Promise<ICustomEmoji[]> => (await appAPI.get("/emoji")).data,
    /** Удалённые — для картинок в старых сообщениях (S4.1). */
    listDeleted: async (): Promise<ICustomEmoji[]> => (await appAPI.get("/emoji/deleted")).data,
    create: async (name: string, file: File): Promise<ICustomEmoji> => {
        const form = new FormData();
        form.append("name", name);
        form.append("file", file, file.name);
        return (await appAPI.post("/emoji", form, {headers: {"Content-Type": "multipart/form-data"}})).data;
    },
    remove: async (id: string): Promise<{id: string}> => (await appAPI.delete(`/emoji/${id}`)).data,
};
